





























import {Component, PropSync} from 'vue-property-decorator'
import BaseFilter from "@/components/Filter/BaseFilter";
import {SmsFilterFilter} from "@/store/sms/filters/types";
import {SelectWings, ToggleWings} from "wings-ui-components";
import {Action, Getter} from "vuex-class";
import {MsgTransports, SelectItem} from "@/store/types";
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({components: {SelectWings, ToggleWings}})
export default class SmsFiltersFilter extends BaseFilter<SmsFilterFilter>{
  @PropSync('show') is_show!: boolean;
  @Getter("smsFilterConditionsList") smsFilterConditionsList: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("getSmsFilters") actionGetSmsFilters: any;
  private transport: MsgTransports = MsgTransports.SMS

  defaultFilter(): SmsFilterFilter {
    return {
      partner: undefined,
      condition: undefined,
      text: undefined,
    }
  }

  params = {transport: this.transport.toString()};
  partnersList: any = []

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners({...this.params, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async created() {
    this.filtered();
    if (this.filter.partner) this.partnersList = await this.actionGetPartners({name: this.filter.partner});
  }

  async onFilteredAction() {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "The rule for blocking by text",
        addititional_info: getTranslatedParams(this.filter)
      };
      await this.actionGetSmsFilters(this.filter);
      await this.actionLog(this.logObject);
    }
    catch (err){
      await this.actionLog({...this.logObject, action_status: "failed"});
    }
  }

  getConditionText(value:string):string|undefined {
    return (<SelectItem[]>this.smsFilterConditionsList)
      .find((obj: SelectItem) => obj.value === value)?.text
  }
}
